export type ContactInfoType = 'Email' | 'Phone number';

export enum TrackingSurveyTypes {
  CustomerFeedback = 'customer_feedback',
  OpenFeedback = 'open_feedback',
  Rating = 'rating',
  Referral = 'referral',
  RepeatBusiness = 'repeat_business',
  Testimonial = 'testimonial',
}

/* SCS contract */
export enum ViewType {
  WEB = 'WEB',
  EMAIL = 'EMAIL',
}

export enum NameFieldMaxLength {
  DEFAULT = 40,
  EXTENDED = 64,
}
